import styled, { css } from 'styled-components';
import Tooltip from '../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: #f8f7f7;
  border-radius: 10px;
  border: 2px solid #e3e3e3;
  padding: 16px;
  width: 100%;
  color: #999591;
  display: flex;
  align-items: center;
  & + div {
    margin-top: 8px;
  }
  ${props =>
    props.isErrored &&
    css`
      border-color: #c93030;
    `}
  ${props =>
    props.isFocused &&
    css`
      color: #846dd2;
      border-color: #846dd2;
    `}
  ${props =>
    props.isFilled &&
    css`
      color: #846dd2;
    `}
  input {
    flex: 1;
    background: transparent;
    border: 0;
    &::placeholder {
      color: #999591;
    }
  }
  svg {
    margin-right: 16px;
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;
  svg {
    margin: 0;
  }
  span {
    background: #c93030;
    color: #fff;
    &::before {
      border-color: #c93030 transparent;
    }
  }
`;
